/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// cSpell:ignore Congaree

export const EXTERNAL_USER = 'TICKET_EXTERNAL_USER';
export const INTERNAL_USER = 'TICKET_INTERNAL_USER';

export const ERR_V2_REQUIRED = 'additional challenge required';
export const ERR_RATE_LIMIT_EXCEEDED =
    'retry: We are currently experiencing heavy traffic on our site. Please try again.';
export const ERR_YOU_LOOK_FAMILIAR = 'You look familiar! This facility only allows';
export const ERR_YOU_LOOK_FAMILIAR_TOUR = 'You look familiar! This tour only allows';
export const ERR_BUSY = 'Looks like a lot of people are trying to book this time';
export const ERR_CHALLENGE_FAILED = 'challenge failed';
export const ERR_NO_LONGER_AVAILABLE = 'Looks like this is a popular location';
export const ERR_TOUR_INSTANCE_CLOSED = 'closed_tour_instance';
// Facility Ids
export const PEARL_HARBOR_ID = '233338';
export const MT_RUSHMORE_FIREWORKS_ID = '300010';
export const EASTER_EGG_ROLL_ID = '250029';
export const FIREFLY_EVENT_ID = '233374';
export const CHRISTMAS_TREE_LIGHTING_ID = '250006';
export const ROCKY_MOUNTAINS_TIMED_ENTRY_ID = '300013';
export const YOSEMITE_TIMED_ENTRY_ID = '300015';
export const ZION_SHUTTLES_ID = '300016';
export const CAPE_LOOKOUT_DUCK_BLIND_ID = '10063832';
export const CONGAREE_FIREFLIES_ID = '300008';
export const FIREFLY_ID = '233374';
export const WASHINGTON_MONUMENT_ID = '234635';
export const HALEAKALA_SUNRISE_ID = '253731';
export const DENALI_ID = '300014';
export const PEARL_HARBOR_LOTTERY_ID = '10088311';
export const PEARL_HARBOR_LOTTERY_2_ID = '10088380';
export const MAMMOTH_CAVE_NP_TEDDY_ABRAMS = '10090873'; // Mammoth Cave National Park presents Teddy Abrams and the Louisville Orchestra with special guest Yo-Yo
export const THOMAS_EDISON_NATIONAL_PARK = '10090620'; // Thomas Edison National Historical Park Tours
export const EL_PORTAL_VISITOR_CENTER_ID = '10089811';
export const MINNETONKA_CAVE_ID = '10087702';
export const MAMMOTH_CAVE_FLOYD_COLLINS = '10112438'; // Mammoth Cave National Park Floyd Collins History Tour Lottery
export const RUEDI_BOAT_STORAGE_PARKING_LOT_LOTTERY = '10112542';
// Tour Ids
export const MINNETONKA_CAVE_GROUP_TOUR_ID = '10089707';
// Facilities with hidden fees
export const FACILITIES_WITH_HIDDEN_FEE_TAB = [
    CHRISTMAS_TREE_LIGHTING_ID,
    EASTER_EGG_ROLL_ID,
    MT_RUSHMORE_FIREWORKS_ID,
];

export const FACILITIES_WITH_HIDDEN_FEES = [
    CHRISTMAS_TREE_LIGHTING_ID,
    EASTER_EGG_ROLL_ID,
];

// Lotteries
export const LOTTERIES = [
    CHRISTMAS_TREE_LIGHTING_ID,
    EASTER_EGG_ROLL_ID,
    FIREFLY_EVENT_ID,
    CAPE_LOOKOUT_DUCK_BLIND_ID,
    MT_RUSHMORE_FIREWORKS_ID,
    CONGAREE_FIREFLIES_ID,
    PEARL_HARBOR_LOTTERY_ID,
    PEARL_HARBOR_LOTTERY_2_ID,
    MAMMOTH_CAVE_NP_TEDDY_ABRAMS,
    THOMAS_EDISON_NATIONAL_PARK,
    MAMMOTH_CAVE_FLOYD_COLLINS,
    RUEDI_BOAT_STORAGE_PARKING_LOT_LOTTERY,
];

export const LOTTERIES_WITH_APPLICATION_FEES = [
    FIREFLY_EVENT_ID,
    CONGAREE_FIREFLIES_ID,
    MT_RUSHMORE_FIREWORKS_ID,
    CAPE_LOOKOUT_DUCK_BLIND_ID,
    PEARL_HARBOR_LOTTERY_ID,
    PEARL_HARBOR_LOTTERY_2_ID,
    MAMMOTH_CAVE_NP_TEDDY_ABRAMS,
    THOMAS_EDISON_NATIONAL_PARK,
    MAMMOTH_CAVE_FLOYD_COLLINS,
    RUEDI_BOAT_STORAGE_PARKING_LOT_LOTTERY,
];

export const CAPTCHA_FACILITIES = [
    PEARL_HARBOR_ID,
    WASHINGTON_MONUMENT_ID,
    HALEAKALA_SUNRISE_ID, // Haleakala National Park Summit Sunrise Reservations
    ROCKY_MOUNTAINS_TIMED_ENTRY_ID, // Rocky Mountain National Park Timed Entry
    DENALI_ID, // Denali Park Road Timed Entry
    YOSEMITE_TIMED_ENTRY_ID, // Yosemite National Park Ticketed Entry
    ZION_SHUTTLES_ID, // Zion National Park Shuttle Tickets
];

// sales channels
export const SALES_CHANNEL_WEB = 'WEB';
export const SALES_CHANNEL_FIELD_SALES = 'FIELD_SALES';
export const SALES_CHANNEL_CALL_CENTER = 'CALL_CENTER';

// Types for determining how to render the guest type
// selector for a given choice for a lottery application
export const GUEST_TYPE_SELECTOR_TYPES = {
    QUANTITY: 'quantity',
    GUEST_TYPE: 'guest_type',
    GUEST_COUNTER: 'guest_counter',
};

// This is used to determine to the trasition timeout speed of the mobile details panel.
export const TRANSITION_TIMEOUT = 300;

export const COMMERCIAL_ACCOUNT_TYPE = 'COMM';

// TODO: Temporary facilities id to validate commercial tours(We need to handle this in a different way)
// We do this because NARA have an special setup(tours needs to be visible for FIT and COMM users)
export const FACILITIES_WITH_COMMERCIAL_VALIDATION = [PEARL_HARBOR_ID];

// TODO: Temporary commercial tours id(We need to handle this in a different way)
export const COMMERCIAL_TOURS = ['10089777'];

// agency names
export const NPS_AGENCY = 'NPS';

// Time interval when data becomes stale so we query the api again(for fetching availability)
export const MAX_STALE_TIME = 1 * 60 * 1000; // 1 minute

// facilities that includes first come first served
export const INCLUDE_FIRST_COME_FIRST_SERVED = [
    EL_PORTAL_VISITOR_CENTER_ID,
    MINNETONKA_CAVE_ID,
];

export const FACILITIES_WITH_RESIDENT_VALIDATION = [MT_RUSHMORE_FIREWORKS_ID];
